

export const webTittle = (title) => {
    document.title="আমার বিল"+ " " + title;
};
